import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { PATHS } from '../../config/consts';
import actions, { selectors as commonSelectors } from '../../modules/common';
import GTCItem from './GTCItem';
import GTCLayout from './GTCLayout';
import GTCWrapper from './GTCWrapper';
import { getGTCListData } from './helper';
import messages from './messages';

export interface IGTCData {
  description: string;
  id: number;
  name: string;
  nextId: number;
  path: string;
  versions: IGTCData[];
}

const GTC_TEST_IDS: Record<string, string> = {
  'cloud-agreement': 'legal-cloud-agreement-link',
  consumers: 'legal-consumers-link',
  'cookie-policy': 'legal-cookie-policy-link',
  'data-processing': 'legal-data-processing-link',
  integrator: 'legal-integrator-link',
  privacy: 'legal-privacy-link',
  processors: 'legal-processors-link',
  'terms-of-service': 'legal-tos-link',
};

function getGtcTestId(path: string): string | undefined {
  const key = Object.keys(GTC_TEST_IDS).find((k) => path?.includes(k));
  return key ? GTC_TEST_IDS[key] : undefined;
}

export function GTCPage() {
  const dispatch = useDispatch();
  const gtcData = useSelector(commonSelectors.getGTCList);

  useEffect(() => {
    dispatch(actions.loadGTCList());
  }, []);

  return (
    <GTCLayout>
      <GTCWrapper title={<FormattedMessage {...messages.gtcTitle} />}>
        {getGTCListData(gtcData).map((item: IGTCData) => (
          <GTCItem
            basePath={PATHS.GTC_PAGE_DETAIL}
            dataTestId={getGtcTestId(item.path)}
            description={item.description}
            key={item.id}
            name={item.name}
            versions={item.versions}
          />
        ))}
      </GTCWrapper>
    </GTCLayout>
  );
}
